// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calender-container {
  position: relative;
}
.calender-container .calendar-selected {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 0.75vw;
  border: 0.5px solid #616161;
  border-radius: 0.2vw;
}
.calender-container .calendar-selected svg {
  width: 0.4vw;
}
.calender-container .calendar-selected button {
  margin: 0;
  padding: 0 1.5vw;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75vw;
}
.calender-container .calendar-selected button span {
  font-size: 0.83vw;
  font-weight: 400;
  color: #616161;
}
.calender-container .calendar {
  width: max-content;
  margin: 0 auto;
  display: flex;
  gap: 0.5vw;
  background: rgb(255, 255, 255);
  z-index: 99;
  padding: 1vw;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  border-radius: 0.3vw;
  position: absolute;
  right: 0;
  transform: translate(0%, 5%);
}
.calender-container .calendar .calendar-option .options {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: max-content;
  gap: 0.75vw;
  align-items: flex-start;
}
.calender-container .calendar .calendar-option .options button {
  border: none;
  background: transparent;
  padding: 0.2vw;
  border-radius: 0.3vw;
  font-size: 0.834vw;
  font-weight: 400;
  color: #616161;
  width: 100%;
  text-align: left;
  cursor: pointer;
}
.calender-container .calendar .calendar-option .options button.active {
  color: #ee3a24;
  background: rgba(238, 58, 36, 0.2705882353);
}
.calender-container .calendar .calendar-option .options button.active::after {
  height: 0;
}
.calender-container .calendar .calendar-data {
  width: 15vw;
  min-width: 215px;
}
.calender-container .calendar .calendar-data .header.row.flex-middle .col.col-start {
  padding: 0;
  text-align: left;
}
.calender-container .calendar .calendar-data .header.row.flex-middle .col.col-start p {
  color: #505050;
  font-size: 0.84vw;
  font-weight: 400;
}
.calender-container .calendar .calendar-data .header.row.flex-middle .col.col-end {
  padding: 0;
  text-align: right;
}
.calender-container .calendar .calendar-data .header.row.flex-middle .col.col-end svg {
  cursor: pointer;
  width: 0.4vw;
  margin: 0 0.5vw;
}
.calender-container .calendar .calendar-data .days.row .col.col-center {
  font-weight: 500;
  font-size: 0.77vw;
  color: #333;
}
.calender-container .calendar .calendar-data .body .row {
  gap: 0;
}
.calender-container .calendar .calendar-data .body .cell.selected .number {
  color: #ee3a24;
}
.calender-container .calendar .calendar-data .body .cell .number {
  font-size: 0.77vw;
  font-weight: 500;
  color: #616161;
}
.calender-container .calendar .calendar-data .body .cell.disabled {
  opacity: 0;
  height: 0;
  pointer-events: none;
}
.calender-container .calendar .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 1px;
}
.calender-container .calendar .days,
.calender-container .calendar .body {
  display: flex;
  flex-direction: column;
}
.calender-container .calendar .row {
  display: flex;
  flex-direction: row;
}
.calender-container .calendar .col {
  flex: 1 1;
  padding: 5px;
  text-align: center;
}
.calender-container .calendar .cell {
  cursor: pointer;
}
.calender-container .calendar .cell.disabled {
  color: #ccc;
}
.calender-container .calendar .cell.selected {
  color: #ee3a24;
  background: rgba(238, 58, 36, 0.2705882353);
}`, "",{"version":3,"sources":["webpack://./src/style/components/analytics/Calendar.scss"],"names":[],"mappings":"AAAA;EAyBE,kBAAA;AAvBF;AADE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,2BAAA;EACA,oBAAA;AAGJ;AAFI;EACE,YAAA;AAIN;AAFI;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAIN;AAHM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAKR;AAAE;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,+DAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,4BAAA;AAEJ;AACM;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AACR;AAAQ;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAEV;AADU;EACE,cAAA;EACA,2CAAA;AAGZ;AAFY;EACE,SAAA;AAId;AAEI;EACE,WAAA;EACA,gBAAA;AAAN;AAEQ;EACE,UAAA;EACA,gBAAA;AAAV;AACU;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;AACZ;AAEQ;EACE,UAAA;EACA,iBAAA;AAAV;AACU;EACE,eAAA;EACA,YAAA;EACA,eAAA;AACZ;AAKQ;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;AAHV;AAOQ;EACE,MAAA;AALV;AASY;EACE,cAAA;AAPd;AAWU;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AATZ;AAYQ;EACE,UAAA;EACA,SAAA;EACA,oBAAA;AAVV;AAgBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAdN;AAiBI;;EAEE,aAAA;EACA,sBAAA;AAfN;AAkBI;EACE,aAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,SAAA;EACA,YAAA;EACA,kBAAA;AAjBN;AAoBI;EACE,eAAA;AAlBN;AAqBI;EACE,WAAA;AAnBN;AAsBI;EACE,cAAA;EACA,2CAAA;AApBN","sourcesContent":[".calender-container{\n  .calendar-selected{\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    padding: 0 .75vw;\n    border: .5px solid #616161;\n    border-radius: .2vw;\n    svg{\n      width: .4vw;\n    }\n    button{\n      margin: 0;\n      padding: 0 1.5vw;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: .75vw;\n      span{\n        font-size: .83vw;\n        font-weight: 400;\n        color: #616161;\n      }\n    }\n  }\n  position: relative;\n  .calendar {\n    width: max-content;\n    margin: 0 auto;\n    display: flex;\n    gap: 0.5vw;\n    background: rgba(255, 255, 255, 1);\n    z-index: 99;\n    padding: 1vw;\n    box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n    border-radius: 0.3vw;\n    position: absolute;\n    right: 0;\n    transform: translate(-0%, 5%);\n  \n    .calendar-option {\n      .options {\n        display: flex;\n        justify-content: space-between;\n        flex-direction: column;\n        width: max-content;\n        gap: 0.75vw;\n        align-items: flex-start;\n        button {\n          border: none;\n          background: transparent;\n          padding: 0.2vw;\n          border-radius: 0.3vw;\n          font-size: 0.834vw;\n          font-weight: 400;\n          color: #616161;\n          width: 100%;\n          text-align: left;\n          cursor: pointer;\n          &.active {\n            color: #ee3a24;\n            background: #ee3a2445;\n            &::after{\n              height: 0;\n            }\n          }\n        }\n      }\n    }\n    .calendar-data {\n      width: 15vw;\n      min-width: 215px;\n      .header.row.flex-middle {\n        .col.col-start {\n          padding: 0;\n          text-align: left;\n          p {\n            color: #505050;\n            font-size: 0.84vw;\n            font-weight: 400;\n          }\n        }\n        .col.col-end {\n          padding: 0;\n          text-align: right;\n          svg {\n            cursor: pointer;\n            width: 0.4vw;\n            margin: 0 0.5vw;\n          }\n        }\n      }\n      .days.row {\n  \n        .col.col-center {\n          font-weight: 500;\n          font-size: 0.77vw;\n          color: #333;\n        }\n      }\n      .body {\n        .row{\n          gap: 0;\n        }\n        .cell{\n          &.selected{\n            .number{\n              color: #ee3a24;\n            }\n           \n          }\n          .number {\n            font-size: .77vw;\n            font-weight: 500;\n            color:  #616161;\n            \n        }\n        &.disabled{\n          opacity:0;\n          height:0;\n          pointer-events:none\n      }\n        }\n      }\n    }\n  \n    .header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      min-height: 1px;\n    }\n  \n    .days,\n    .body {\n      display: flex;\n      flex-direction: column;\n    }\n  \n    .row {\n      display: flex;\n      flex-direction: row;\n    }\n  \n    .col {\n      flex: 1;\n      padding: 5px;\n      text-align: center;\n    }\n  \n    .cell {\n      cursor: pointer;\n    }\n  \n    .cell.disabled {\n      color: #ccc;\n    }\n  \n    .cell.selected {\n      color: #ee3a24;\n      background: rgba(238, 58, 36, 0.2705882353);\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
